var _path, _path2, _path3, _path4;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPremium(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0514 19.0849C14.4028 18.158 9.6169 18.158 4.9683 19.0849L3.50537 8.64941L8.30376 14.1403L12.0098 8.64941L15.7159 14.1403L20.5143 8.64941L19.0514 19.0849Z",
    stroke: "#FFC600",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9848 6.65996C12.7303 6.65996 13.3348 6.05555 13.3348 5.30996C13.3348 4.56438 12.7303 3.95996 11.9848 3.95996C11.2392 3.95996 10.6348 4.56438 10.6348 5.30996C10.6348 6.05555 11.2392 6.65996 11.9848 6.65996Z",
    fill: "#FFC600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40225 6.65996C4.14783 6.65996 4.75225 6.05555 4.75225 5.30996C4.75225 4.56438 4.14783 3.95996 3.40225 3.95996C2.65666 3.95996 2.05225 4.56438 2.05225 5.30996C2.05225 6.05555 2.65666 6.65996 3.40225 6.65996Z",
    fill: "#FFC600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5673 6.65996C21.3129 6.65996 21.9173 6.05555 21.9173 5.30996C21.9173 4.56438 21.3129 3.95996 20.5673 3.95996C19.8217 3.95996 19.2173 4.56438 19.2173 5.30996C19.2173 6.05555 19.8217 6.65996 20.5673 6.65996Z",
    fill: "#FFC600"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPremium);
export default __webpack_public_path__ + "static/media/icon_premium.7eb1649318d6fca0eb65052c1d58d1ac.svg";
export { ForwardRef as ReactComponent };